import route from "@/components/router/Router"
const routes = [
    {
        path : "officebuilding-carrier-add",
        name : "officebuilding-carrier-add",
        meta : {
            title : "写字楼载体-载体录入"
        },
        component: () => import('@/pages/officebuilding/inputCarrier/Index')
    },
    {
        path : "officebuilding-carrier-edit/:id",
        name : "officebuilding-carrier-edit",
        meta : {
            title : "写字楼载体-载体录入"
        },
        component: () => import('@/pages/officebuilding/inputCarrier/Index')
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/router/officebuilding/inputcarrier/index.js